import { useEffect, useState } from "react";
import { TAB_FROM_INDEX_RFX_EVALUATION } from "../modules/vscDashboard/constants";
import { chartColors, dummyDataset } from "../common/constants";
import { listEvaluatedRfxFilesData } from "../services/common.service";
import { useSearchParams } from "react-router-dom";

export const useRfxHook = () => {
  const [data, setData] = useState([
    {
      id: 0,
      category_score_json: {
        "EXPERIENCE & GENERAL CAPABILITIES": {},
        Overall_Summary: "",
      },
      summary: "",
    },
  ]);
  const [selectedFileData, setSelectedFileData] = useState(data?.[0]);
  const [showPresentationBanner, setShowPresentationBanner] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeToggle, setActiveToggle] = useState("Score Card");

  const [searchParams] = useSearchParams();
  const productId = searchParams.get("productId") || "";
  const [selectedTab, setSelectedTab] = useState(0);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [chartColor, setChartColor] = useState("blue");

  const isPresentation = selectedTab === 3;
  const categorical_data: any = selectedFileData?.category_score_json;
  const tabData: any = TAB_FROM_INDEX_RFX_EVALUATION[selectedTab];
  const points: any = categorical_data?.[tabData];
  let pointsGot = isPresentation ? 0 : points?.Total_Score;

  const parameters = Object?.keys(points || {})
    ?.map((point: any) => {
      if (point !== "Total_Score" && point !== "Summary") {
        return {
          point: point,
          description: points?.[point]?.description || "N/A",
          score: `${isPresentation ? 0 : points?.[point]?.score}/${
            isPresentation ? 0 : 2
          }`,
        };
      }
    })
    .filter((obj) => obj);

  const files = data?.map((fileData: any) => {
    return { fileName: fileData?.rfx_response_file_name, id: fileData?.id };
  });

  const handleFileSelect = (file_id: number) => {
    if (selectedFileData.id === file_id) return;
    const fileObjIdx = data?.findIndex(
      (fileData: any) => fileData?.id === file_id
    );
    if (fileObjIdx > -1) {
      setSelectedFileData(data[fileObjIdx]);
      setChartColor(chartColor === "blue" ? "green" : "blue");
    }
    setDropdownOpen(false);
  };

  const handleForwardClick = () => {
    if (currentFileIndex + 3 < files?.length) {
      setCurrentFileIndex(currentFileIndex + 3);
        }
  };

  const handleBackwardClick = () => {
    if (currentFileIndex- 3 >= 0) {
      setCurrentFileIndex(currentFileIndex - 3);
        }
    
  };
  const handleToggleClick = (
    event: React.MouseEvent<HTMLElement>,
    newToggle: string
  ) => {
    if (newToggle !== null) {
      setActiveToggle(newToggle);
    }
  };

  const visibleFiles = files.slice(currentFileIndex, currentFileIndex + 3);

  const getParamaterData = (index: number) => {
    return categorical_data?.[TAB_FROM_INDEX_RFX_EVALUATION[index]];
  };
  const getScore = (index: number) => {
    const tabData = getParamaterData(index);
    const total = Object.keys(tabData || {}).length * 2;
    const pointsGot = tabData?.Total_Score || 0;
    return { pointsGot, total: total >= 4 ? total - 4 : 0 };
  };

  const chartBottomData = [
    {
      text: "Experience & General Capabilities",
      pointsGot: getScore(0).pointsGot,
      total: getScore(0).total,
      score: `${getScore(0).pointsGot}/${getScore(0).total}`,
      color: chartColors?.[chartColor][0],
      summary: getParamaterData(0)?.Summary,
    },
    {
      text: "Case Studies",
      pointsGot: getScore(1).pointsGot,
      total: getScore(1).total,
      score: `${getScore(1).pointsGot}/${getScore(1).total}`,
      color: chartColors?.[chartColor][1],
      summary: getParamaterData(1)?.Summary,
    },
    {
      text: "Partnership Potential",
      pointsGot: getScore(2).pointsGot,
      total: getScore(2).total,
      score: `${getScore(2).pointsGot}/${getScore(2).total}`,
      color: chartColors?.[chartColor][2],
      summary: getParamaterData(2)?.Summary,
    },
    {
      text: "Presentation",
      pointsGot: 0,
      total: 0,
      score: `0/0`,
      color: chartColors?.[chartColor][3],
    },
  ];

  let totalPointsGot = 0;
  let totalPointsAvailable = 0;

  chartBottomData.forEach((chartObj) => {
    totalPointsGot += chartObj.pointsGot;
    totalPointsAvailable += chartObj.total;
  });

  const totalScoreText = `${totalPointsGot}/${totalPointsAvailable}`;

  const parameterDataForSummary = chartBottomData
    .map((parameterData) => {
      return {
        score: parameterData.score,
        text: parameterData.text,
        summary: parameterData.summary,
      };
    })
    .filter((paramater) => paramater.text !== "Presentation");

  const summaryData = {
    final_score: totalScoreText,
    overall_summary: categorical_data?.Overall_Summary,
    data: parameterDataForSummary,
  };

  const dataobj = {
    ...dummyDataset.datasets[0],
    data: chartBottomData?.map((dataObj: any) => dataObj?.pointsGot),
    backgroundColor: chartColors?.[chartColor],
    borderColor: chartColors?.[chartColor],
    centerText: totalScoreText,
  };

  const dataForChart = {
    ...dummyDataset,
    datasets: [dataobj],
  };

  const getEvaluatedRfcFilesData = async () => {
    const res = await listEvaluatedRfxFilesData({
      product_area_id: productId,
    });
    setData(res);
    setSelectedFileData(res?.[0]);
  };

  useEffect(() => {
    getEvaluatedRfcFilesData();
  }, [searchParams]);

  return {
    dataForChart: dataForChart,
    chartBottomData: chartBottomData,
    visibleFiles: visibleFiles,
    parameters: parameters,
    pointsGot: pointsGot,
    pointsTotal: isPresentation ? 0 : parameters.length,
    files: files,
    handleBackwardClick: handleBackwardClick,
    handleForwardClick: handleForwardClick,
    handleFileSelect: handleFileSelect,
    selectedFileData: selectedFileData,
    handleToggleClick: handleToggleClick,
    activeToggle: activeToggle,
    dropdownOpen: dropdownOpen,
    currentFileIndex: currentFileIndex,
    selectedTab: selectedTab,
    setSelectedTab: setSelectedTab,
    summaryData: summaryData,
    isPresentation: isPresentation,
    showPresentationBanner: showPresentationBanner,
    setShowPresentationBanner: setShowPresentationBanner,
    fileIdForShowingStar: data[0]?.id,
  };
};
